import {
  SfSelectData,
  SfSelectFormField,
  SfSelectOption,
} from 'ngx-smart-form';
import { IFormField } from 'ngx-smart-form/lib/smart-form/interfaces/i-form-field';
import { AttivitaSvoltaEnum } from './attivita-svolta-enum';
import { addEmptyOption } from '../../_utils/utils';

export class AttivitaSvoltaField extends SfSelectFormField<
  {
    attivitaSvolta: string;
  },
  AttivitaSvoltaEnum | null
> {
  constructor(
    fieldSettings: Partial<IFormField<{ attivitaSvolta: string }>> &
      SfSelectData
  ) {
    let options: SfSelectOption<AttivitaSvoltaEnum | null>[] = addEmptyOption(
      Object.values(AttivitaSvoltaEnum).map((attivita) => ({
        value: attivita,
        view: attivita,
      })),
      true
    );

    super({
      formControlName: 'attivitaSvolta',
      label: fieldSettings.label || 'Attività svolta',
      required: fieldSettings?.required || false,
      options,
      value: fieldSettings?.value || undefined,
    });
  }
}
